import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DependencyTrackProjectsService } from '../../services/dependency-track-projects/dependency-track-projects.service';

@Component({
  selector: 'app-dependency-track-components',
  templateUrl: './dependency-track-components.component.html',
  styleUrls: ['./dependency-track-components.component.css']
})
export class DependencyTrackComponentsComponent implements OnInit, OnChanges {
  @Input() projectId: string = ''; 
  @Input() items: any[] = [];

  components: any[] | null = null; 
  loading: boolean = false;

  filterFields: Array<string> = ['name', 'purl'];
  // Colunas da tabela de componentes do PO-UI
  componentColumns: any[] = [
   { property: 'name', label: 'Nome', width: '300px', sortable: true },
    { property: 'version', label: 'Versão', width: '200px', sortable: true },
    { property: 'purl', label: 'PURL', sortable: true }
  ];

  constructor(
    private projectService: DependencyTrackProjectsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.items && this.items.length > 0) {
      this.treatComponentsArray(this.items);
    } else if (this.projectId) {
      this.loadComponents();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectId'] && changes['projectId'].currentValue) {
      this.loadComponents();
    }
    if (changes['items'] && changes['items'].currentValue) {
      this.treatComponentsArray(changes['items'].currentValue);
    }
  }

  loadComponents() {
    this.loading = true;
    this.projectService.getProjectComponents(this.projectId).subscribe({
      next: (response: any) => {
        if (response) {          
          let rawComponents: any[] = [];
          if (response.items && response.items.length > 0) {
            rawComponents = response.items[0].components || response.items[0].components_details || [];
          } 
          else if (response.components) {
            rawComponents = response.components;
          }
          else if (Array.isArray(response) && response.length > 0) {
            rawComponents = response[0].components || response[0].components_details || response;
          } 
          else if (Array.isArray(response)) {
            rawComponents = response;
          }
          this.treatComponentsArray(rawComponents);
        } else {
          this.components = [];
        }
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro ao buscar componentes do projeto', err);
        this.components = [];
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  private treatComponentsArray(rawArray: any[]) {
    if (!rawArray) {
      this.components = [];
      return;
    }

    this.components = rawArray.map((item: any) => {
      let nomeCompleto = item.name || '';
      if (item.group) {
        const groupClean = item.group.replace('@', '').trim();
        const nameClean = item.name.trim();

        nomeCompleto = nameClean.startsWith(groupClean) ? nameClean : `${groupClean}/${nameClean}`;
      }
      
      const decodedPurl = item.purl ? decodeURIComponent(item.purl) : '';
      let versao = item.version || '-';
      if (!item.version && decodedPurl.includes('@')) {
        const lastAtIndex = decodedPurl.lastIndexOf('@');
        if (lastAtIndex > 4) { 
          versao = decodedPurl.substring(lastAtIndex + 1);
        }
      }

      return {
        name: nomeCompleto,
        version: versao,
        purl: decodedPurl
      };
    });
    
    this.cdr.detectChanges();
  }
}